import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from '@app/app.module';
import { environment } from './environments/environment';

if (environment.production) {
  enableProdMode();
}

/**
 * Listener global para capturar Promise rejections no manejadas.
 * Solo reporta a New Relic si Angular NO ha arrancado aún (pre-bootstrap).
 * Una vez que Angular inicia, el GlobalErrorHandler se encarga de estos errores
 * evitando métricas duplicadas.
 */
let angularBootstrapped = false;

window.addEventListener('unhandledrejection', (event: PromiseRejectionEvent) => {
  if (angularBootstrapped) return; // GlobalErrorHandler ya se encarga

  const nr = (window as any).newrelic;
  if (!nr) return;

  const error =
    event.reason instanceof Error ? event.reason : new Error(String(event.reason));

  const attrs = {
    name: 'KIOSK_SSBD',
    actionSubname: 'KIOSK_UNHANDLED_ERROR',
    errorSource: 'UnhandledRejection-PreBootstrap',
    errorType: error.name || 'Unknown',
    errorMessage: (error.message || '').substring(0, 500),
    errorStack: (error.stack || '').substring(0, 1000),
    currentRoute: window.location.hash || window.location.pathname,
    isSSBD: true,
    isError: true,
    timestamp: new Date().toISOString(),
  };

  if (nr.noticeError) {
    nr.noticeError(error, attrs);
  }
  if (nr.addPageAction) {
    nr.addPageAction('KIOSK_SSBD', attrs);
  }
});
platformBrowserDynamic()
  .bootstrapModule(AppModule)
  .then(() => {
    angularBootstrapped = true;
  })
  .catch(err => console.error(err));
